/* RescueNation Cart Drawer — AJAX add/update/remove + toast */
(function () {
  var root = document.querySelector('[data-rn-cart-root]');
  var toast = document.querySelector('[data-rn-toast]');
  if (!root) return;

  var moneyFormat = (window.Shopify && Shopify.money_format) || '€ {{amount}}';

  function formatMoney(cents) {
    var n = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '€ ' + n;
  }

  function openDrawer() {
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    root.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function showToast(msg) {
    if (!toast) return;
    var msgEl = toast.querySelector('[data-rn-toast-msg]');
    if (msgEl) msgEl.textContent = msg || 'Im Warenkorb';
    toast.classList.add('is-visible');
    clearTimeout(window._rnToastTimer);
    window._rnToastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  function updateAllCartCounts(count) {
    document.querySelectorAll('[data-rn-cart-count], .rn-header__cart .count, .rn-cart-btn .count').forEach(function (el) {
      el.textContent = count;
      if (el.closest('.rn-header__cart')) {
        el.closest('.rn-header__cart').setAttribute('data-empty', count === 0 ? 'true' : 'false');
      }
    });
  }

  function rerenderDrawer() {
    return fetch('?section_id=rn-cart-drawer-section', { credentials: 'same-origin' })
      .catch(function () { /* ignore — fallback below */ })
      .then(function () {
        // Fallback: fetch full cart and re-render minimally via /cart.js
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateAllCartCounts(cart.item_count);
            var sub = document.querySelector('[data-rn-cart-subtotal]');
            if (sub) sub.textContent = formatMoney(cart.total_price);
            var foot = document.querySelector('[data-rn-cart-foot]');
            if (foot) {
              if (cart.item_count === 0) foot.setAttribute('hidden', '');
              else foot.removeAttribute('hidden');
            }
            return cart;
          });
      });
  }

  function rerenderItems() {
    // Use Shopify Section Rendering API for clean re-render of the items snippet
    return fetch('/?sections=rn-cart-drawer-section', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['rn-cart-drawer-section']) {
          var temp = document.createElement('div');
          temp.innerHTML = data['rn-cart-drawer-section'];
          var newBody = temp.querySelector('[data-rn-cart-body]');
          var oldBody = document.querySelector('[data-rn-cart-body]');
          if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
        }
      })
      .catch(function () { /* graceful */ });
  }

  function refreshAll() {
    return Promise.all([rerenderDrawer(), rerenderItems()]);
  }

  // === Add to cart (intercept all .rn-pdp__form submissions) ===
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rn-pdp], .rn-add-to-cart-form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var originalLabel = btn ? btn.innerHTML : null;
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span style="opacity:.7">Hinzufügen…</span>';
    }

    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart_add_failed');
        return r.json();
      })
      .then(function (item) {
        var qty = parseInt(fd.get('quantity'), 10) || 1;
        var name = (item && item.product_title) ? item.product_title : 'Artikel';
        showToast(qty + '× ' + name + ' im Warenkorb');
        return refreshAll();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function () {
        showToast('Fehler — bitte erneut versuchen');
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          if (originalLabel) btn.innerHTML = originalLabel;
        }
      });
  });

  // === Line updates (qty +/-) ===
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-rn-line-update]');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-rn-line-update');
      var dir = parseInt(qtyBtn.getAttribute('data-rn-line-dir'), 10);
      var itemEl = qtyBtn.closest('.rn-drawer__item');
      var current = itemEl ? parseInt(itemEl.querySelector('.rn-drawer__qty-n').textContent, 10) : 1;
      var next = Math.max(0, current + dir);
      changeLine(key, next);
      return;
    }

    var removeBtn = e.target.closest('[data-rn-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.getAttribute('data-rn-line-remove'), 0);
      return;
    }

    var closeBtn = e.target.closest('[data-rn-cart-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var openBtn = e.target.closest('[data-rn-cart-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }
  });

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshAll(); });
  }

  // === Header cart button intercept — open drawer instead of navigating ===
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.rn-header__cart, a.rn-cart-btn');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('/cart') === 0) {
      // allow modifier-clicks (new tab) to pass through
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      openDrawer();
    }
  });

  // Esc to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
  });
})();
